var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgMessageBubble = function SvgSvgMessageBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.748 24a.75.75 0 0 1-.678-1.072l2.911-6.113a11.25 11.25 0 0 1-1.484-5.596C1.507 5.033 6.547 0 12.733 0h.034c2.101 0 4.155.587 5.94 1.696a11.17 11.17 0 0 1 5.011 7c.683 2.93.187 5.946-1.397 8.494a11.18 11.18 0 0 1-6.998 5.016 11.208 11.208 0 0 1-8.139-1.189l-6.112 2.911A.8.8 0 0 1 .748 24M12.733 1.5c-5.36 0-9.727 4.361-9.735 9.721a9.7 9.7 0 0 0 1.47 5.158.75.75 0 0 1 .04.719l-2.174 4.567L6.9 19.49a.75.75 0 0 1 .718.041 9.7 9.7 0 0 0 7.362 1.214 9.7 9.7 0 0 0 6.066-4.347c2.839-4.566 1.434-10.59-3.132-13.428a9.74 9.74 0 0 0-5.148-1.47z"
  })));
};
export default SvgSvgMessageBubble;